import { render, staticRenderFns } from "./modalCuentasCliente.vue?vue&type=template&id=60414b86&"
import script from "./modalCuentasCliente.vue?vue&type=script&lang=js&"
export * from "./modalCuentasCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports